import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
export var ErrorMessageTypes;
(function (ErrorMessageTypes) {
  ErrorMessageTypes["OFFER_UNAVAILABLE"] = "OFFER_UNAVAILABLE";
})(ErrorMessageTypes || (ErrorMessageTypes = {}));
export var CheckAvailabilityMessageBanner = function (_a) {
  var type = _a.type,
    message = _a.message;
  var formatText = useLocalization().formatText;
  if (type === ErrorMessageTypes.OFFER_UNAVAILABLE) {
    return React.createElement(React.Fragment, null, React.createElement(UitkText, {
      align: "left"
    }, React.createElement(UitkSpacing, {
      padding: {
        blockstart: 'six',
        blockend: 'three'
      }
    }, React.createElement(UitkHeading, {
      size: 6,
      tag: "h3"
    }, formatText('lx.activity.checkAvailability.banner.noOfferAvailableHeader', message))), React.createElement(UitkText, {
      size: 300
    }, formatText('lx.activity.checkAvailability.banner.noOfferAvailableText'))));
  }
  return React.createElement("span", null);
};